import React from 'react';
import {
  Row,
  Col,
  Button,
  Input,
  Checkbox,
  Dropdown,
  Icon,
  Menu,
  message,
  Modal
} from 'antd';
import {
  asiapacific,
  americas,
  europe,
  middleeast,
  africa
} from '../../components/ModalSchools/countries.js';
import trackerapps from '../../images/logos/trackerapps.png';
import { compose } from 'redux';
import { firebaseConnect } from 'react-redux-firebase';
import { fbFunctionsURL } from '../../config.js';
import axios from 'axios';
const CheckboxGroup = Checkbox.Group;

class Subscribe extends React.Component {
  state = {
    type: [],
    typeDropdown: '',
    program: [],
    name: '',
    region: 'Africa',
    country: '',
    description: '',
    address: '',
    phone: '',
    email: '',
    id: '',
    products: ['SkillTracker'],
    savedProduct: '',
    history: [],
    //Admin
    firstName: '',
    lastName: '',
    adminEmail: '',
    loading: false
  };

  countries = () => {
    let countries;
    if (this.state.region == 'Asia Pacific') {
      countries = asiapacific;
    } else if (this.state.region == 'Americas') {
      countries = americas;
    } else if (this.state.region == 'Europe') {
      countries = europe;
    } else if (this.state.region == 'Middle East') {
      countries = middleeast;
    } else {
      countries = africa;
    }

    return (
      <Menu onClick={e => this.setState({ country: e.item.props.children })}>
        {countries.map((country, i) => (
          <Menu.Item key={i}>{country}</Menu.Item>
        ))}
      </Menu>
    );
  };

  checkFields = () => {
    if (
      this.state.type.length === 0 ||
      this.state.program.length === 0 ||
      this.state.name === '' ||
      this.state.region === '' ||
      this.state.country === '' ||
      this.state.products === null ||
      this.state.description === '' ||
      this.state.address === '' ||
      this.state.phone === '' ||
      this.state.email === '' ||
      this.state.firstName === '' ||
      this.state.lastName === '' ||
      this.state.adminEmail === ''
    ) {
      message.error('All fields are mandatory');
    } else {
      this.save();
    }
  };

  save = () => {
    this.setState({ loading: true });
    let id = this.props.firebase
      .database()
      .ref()
      .child('schools')
      .push().key;
    const school = {
      active: true,
      //      group: data.group,
      type: this.state.type,
      program: this.state.program,
      name: this.state.name,
      region: this.state.region,
      country: this.state.country,
      description: this.state.description,
      address: this.state.address,
      phone: this.state.phone,
      email: this.state.email,
      products: this.state.products,
      createdAt: Date.now(),
      skill_description:
        '<p><strong>Watch - </strong><em>I know what the use of the skill looks like when others are using it.&nbsp;I need lots of help to use the skill.</em></p><p><strong>Copy - </strong><em>I can copy someone else using the skill. I can use the skill in familiar situations with some help.</em></p><p><strong>Do - </strong><em>I am using the skill by myself in familiar situations. I don’t need help to use the skill anymore.</em></p><p><strong>Teach - </strong><em>I use the   skill without needing to think it through first. I can use the skill in unfamiliar situations without any help from anyone else.</em></p>'
    };

    const adminData = {
      name: this.state.firstName,
      last_name: this.state.lastName,
      email: this.state.adminEmail,
      school_name: this.state.name,
      school_id: id,
      role: 'admin',
      id: false
    };
    this.saveHistory(school, adminData, id);
  };

  saveHistory = (school, adminData, id) => {
    let history = [];
    if (this.state.products.includes('SkillTracker')) {
      history.push({
        productName: 'SkillTracker',
        type: 'subscribed',
        date: Date.now()
      });
    }
    if (this.state.products.includes('ServiceTracker')) {
      history.push({
        productName: 'ServiceTracker',
        type: 'subscribed',
        date: Date.now()
      });
    }

    axios
      .post(`${fbFunctionsURL}/subscribeSchool`, {
        school,
        adminData,
        history,
        id
      })
      .then(() => {
        this.setState({ loading: false });
        Modal.success({
          title: 'Thank you!',
          content:
            'Please check the email sent to your admin email address for next steps.',
          onOk: () => {
            window.location.replace('http://www.tracker-apps.com');
          }
        });
      })
      .catch(() => {
        this.setState({ loading: false });
        Modal.error({
          title: 'An error happened',
          content:
            'Please try again later or contact info@tracker-apps.com for help.'
        });
      });
  };

  onChangeCheckbox = checkedValues => {
    this.setState({ products: checkedValues });
  };

  render() {
    const plainOptions = ['SkillTracker', 'ServiceTracker'];

    const region = (
      <Menu
        onClick={e =>
          this.setState({ region: e.item.props.children, country: '' })
        }>
        <Menu.Item key="0">Africa</Menu.Item>
        <Menu.Item key="1">Asia Pacific</Menu.Item>
        <Menu.Item key="2">Americas</Menu.Item>
        <Menu.Item key="3">Europe</Menu.Item>
        <Menu.Item key="4">Middle East</Menu.Item>
      </Menu>
    );

    const programmes = [
      { label: 'PYB', value: 'PYB' },
      { label: 'DP', value: 'DP' },
      { label: 'CP', value: 'CP' },
      { label: 'MYP', value: 'MYP' },
      { label: 'Another curriculum', value: 'Other' }
    ];

    const schooltypes = [
      { label: 'Goverment / State', value: 'Goverment / State' },
      { label: 'Private', value: 'Private' },
      { label: 'Private International', value: 'Private International' }
    ];

    return (
      <div style={styles.container}>
        <Row
          style={{
            borderBottom: '1px solid rgb(44, 156, 205)',
            maxWidth: 1200,
            margin: '0 auto'
          }}>
          <a href="http://www.tracker-apps.com">
            <img
              style={{
                width: '50%',
                height: 'auto',
                maxWidth: 100,
                margin: '0 auto',
                marginTop: 20,
                display: 'block'
              }}
              src={trackerapps}
            />
          </a>
          <h1 style={styles.header}>SUBSCRIBE TO TRACKER APPS</h1>
          <div
            style={{
              color: 'rgb(44, 156, 205)',
              fontSize: 10,
              display: 'inline-flex',
              width: '100%',
              margin: '0 auto',
              alignItems: 'center',
              justifyContent: 'center',
              marginBottom: 10
            }}>
            <Icon style={{ marginRight: 20 }} type="double-left" />
            <a href="http://www.tracker-apps.com">
              <h1 style={{ margin: 0, color: 'rgb(44, 156, 205)' }}>
                Back to previous page
              </h1>
            </a>
          </div>
        </Row>
        <Row style={{ maxWidth: 1200, margin: '0 auto', display: 'block' }}>
          <Col xs={24} md={11} style={{ padding: 20 }}>
            <h1 style={styles.title}>
              Please fill out your School Information.
            </h1>
            {/*
            <h3 style={styles.heading}>Products</h3>
            <div>
              <CheckboxGroup options={plainOptions} value={this.state.products} onChange={(e) => this.onChangeCheckbox(e)} />
              <br /><br />
            </div>
            */}
            <h3 style={styles.heading}>School Type</h3>
            <CheckboxGroup
              options={schooltypes}
              style={{ marginBottom: '20px' }}
              onChange={e => this.setState({ type: e })}
            />
            <h3 style={styles.heading}>Program</h3>
            <CheckboxGroup
              options={programmes}
              style={{ marginBottom: '20px' }}
              onChange={e => this.setState({ program: e })}
            />
            <h3 style={styles.heading}>School Name</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ name: e.target.value })}
              value={this.state.name}
            />
            <h3 style={styles.heading}>School Description</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ description: e.target.value })}
              value={this.state.description}
            />
            <Row>
              <Col xs={12} style={{ paddingRight: 10 }}>
                <h3 style={styles.heading}>Region</h3>
                <Dropdown
                  style={{ width: '100%' }}
                  overlay={region}
                  placement="bottomRight">
                  <Button style={{ width: '100%' }}>
                    {this.state.region} <Icon type="down" />
                  </Button>
                </Dropdown>
              </Col>
              <Col xs={12} style={{ paddingLeft: 10 }}>
                <h3 style={styles.heading}>School Country</h3>
                <Dropdown
                  style={{ width: '100%' }}
                  overlay={this.countries()}
                  placement="bottomLeft">
                  <Button style={{ width: '100%' }}>
                    {this.state.country == ''
                      ? 'School country'
                      : this.state.country}{' '}
                    <Icon type="down" />
                  </Button>
                </Dropdown>
              </Col>
            </Row>
            <h3 style={styles.heading}>School Address</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ address: e.target.value })}
              value={this.state.address}
            />
            <h3 style={styles.heading}>Contact Phone Number</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ phone: e.target.value })}
              value={this.state.phone}
            />
            <h3 style={styles.heading}>Contact Email Address</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ email: e.target.value })}
              value={this.state.email}
            />
          </Col>
          <Col xs={0} md={2} />
          <Col xs={24} md={11} style={{ padding: 20 }}>
            <h1 style={styles.title}>
              Please add your School Administrator Information
            </h1>
            <h3 style={styles.note}>
              Your School Administrator will be receiving an email with
              instructions of setting up the school.
            </h3>
            <h3 style={styles.heading}>First name</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ firstName: e.target.value })}
              value={this.state.firstName}
            />
            <h3 style={styles.heading}>Last name</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ lastName: e.target.value })}
              value={this.state.lastName}
            />
            <h3 style={styles.heading}>Email</h3>
            <Input
              style={styles.input}
              onChange={e => this.setState({ adminEmail: e.target.value })}
              value={this.state.adminEmail}
            />
            <Button
              loading={this.state.loading}
              style={{
                width: 100,
                backgroundColor: '#428bca',
                borderColor: '#2a6496',
                color: 'white',
                marginTop: 20
              }}
              onClick={() => this.checkFields()}>
              Submit
            </Button>
          </Col>
        </Row>
      </div>
    );
  }
}

const enhancer = compose(firebaseConnect());
export default enhancer(Subscribe);

const styles = {
  container: {
    minHeight: '100vh',
    minWidth: '100vw',
    backgroundColor: 'white'
  },
  title: {
    fontSize: 24,
    fontFamily: 'Avenir',
    fontWeight: 400,
    color: 'rgb(44, 156, 205)',
    textTransform: 'uppercase'
  },
  header: {
    fontSize: 24,
    fontFamily: 'Avenir',
    textAlign: 'center',
    fontWeight: 'bold',
    color: 'rgb(44, 156, 205)',
    textTransform: 'uppercase'
  },
  note: {
    fontSize: 18,
    fontFamily: 'Avenir',
    fontStyle: 'italic',
    color: 'rgb(90, 90, 90)'
  },
  input: {
    borderRadius: 0,
    fontSize: 18
  },
  heading: {
    marginTop: 15,
    marginBottom: 0,
    width: '100%',
    color: 'rgb(90, 90, 90)',
    fontFamily: 'Avenir',
    fontSize: 18,
    fontWeight: 700
  }
};



// WEBPACK FOOTER //
// ./src/containers/Subscribe/index.js